import { project2BaseUrl } from './remoteClient';

export async function userSkillsRequest(token, userId) {
    return await project2BaseUrl.get(`/talent/getTalentSkills?userId=${userId}`, {
        headers: {
            "Authorization": `Bearer ${token}`,
        }
    })
}

export async function deleteMatchRequest(token, xwalkId) {
    return await project2BaseUrl.post('/talent/deleteMatch', xwalkId, {
        headers: {
            "Authorization": `Bearer ${token}`,
        }
    })
}

export async function deleteSourceRequest(token, source) {
    return await project2BaseUrl.post('/talent/deleteSourceMatch', source, {
        headers: {
            "Authorization": `Bearer ${token}`,
        }
    })
}

export async function updateUserRequest(token, updatedUser) {
    return await project2BaseUrl.post("/user/updateUser", updatedUser, {
        headers: {
            "Authorization": `Bearer ${token}`,
        }
    })
}

export async function updateProfeciencyRequest(token, newProficiencies) {
    return await project2BaseUrl.post('/talent/updateTalentSkillsProficiencies', newProficiencies, {
        headers: {
            "Authorization": `Bearer ${token}`,
        }
    });
}

export async function updateFileRequest(token, file, id) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("id", id)

    return await project2BaseUrl.post("/talent/processFile", formData, {
        headers: {
            "Authorization": `Bearer ${token}`,
        }
    });
}

export async function statementSubmitRequest(token, statement, userId) {
    const payload = new FormData();
    payload.append("statement", statement)
    payload.append("userId", userId)

    return await project2BaseUrl.post('/talent/processStatement', payload, {
        headers: {
            "Authorization": `Bearer ${token}`,
        }
    })

}

export async function getUserRequest(token) {
    return await project2BaseUrl.get('/user/getMe', {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export async function deleteUserRequest(token, userId) {
    return await project2BaseUrl.post(`/user/deleteUser`, userId, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}